import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { OfficeAuthProvider } from './auth/OfficeAuthProvider'
import { App } from './taskpane/App'
import './styles.css'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // The pane is opened and closed constantly; refetching on every focus
            // change would hammer BOL2 for data that rarely moves within a session.
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
})

/**
 * Office.onReady must resolve before any Office API is touched, so the app is only
 * mounted once the host runtime is available.
 */
Office.onReady(() => {
    const container = document.getElementById('root')
    if (!container) throw new Error('Missing #root element')

    createRoot(container).render(
        <StrictMode>
            <QueryClientProvider client={queryClient}>
                <OfficeAuthProvider>
                    <App />
                </OfficeAuthProvider>
            </QueryClientProvider>
        </StrictMode>,
    )
})
